import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fc8e9ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "space-y-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "error-text" }
const _hoisted_6 = { key: 0 }

import { authLoginSchema } from '@shared/validation/auth';
import { AuthLoginDto } from '@shared/dto/auth';
import SingleLine from '@ui-kit/inputs/single-line/SingleLine';
import { useValidator } from '@/libs/validator/hooks/use-validator';
import { computed, reactive, ref } from 'vue';
import ValidationKeyObserver from '@components/validation/ValidationKeyObserver.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import AuthService from '@/services/auth.service';
import { AxiosError } from 'axios';
import { useUserStore } from '@/stores/user';
import { useRouter } from 'vue-router';
import RouteNames from '@/router/route-names';
import Label from '@ui-kit/label/Label.vue';
import Card from '@ui-kit/card/Card.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageLogin',
  setup(__props) {

const formData = ref<AuthLoginDto>({
  username: '',
  password: '',
});
const formLoading = ref<boolean>(false);
const authError = ref<boolean>(false);

const validator = useValidator({
  data: formData,
  schema: computed(() => authLoginSchema),
});

const authService = new AuthService();
const userStore = useUserStore();
const router = useRouter();

function submit() {
  authError.value = false;
  if (validator.validate()){
    formLoading.value = true;
    authService.login(formData.value).send().then((response) => {
      const { token, user } = response.data;
      userStore.setData(user, {
        value: token.access_token,
        expires: token.expires_in,
      });
      router.push({name: RouteNames.DASHBOARD});
    }).catch((e: AxiosError) => {
      const status = e.response?.status;
      if (status === 401){
        authError.value = true;
        console.log('need to show incorrect password or email error');
      }
    }).finally(() => {
      formLoading.value = false;
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Card, {
      class: "login-card",
      title: "Log in"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Label, { label: "Username:" }, {
            default: _withCtx(({id}) => [
              _createVNode(ValidationKeyObserver, { keys: "username" }, {
                default: _withCtx(({firstErrorMessage}) => [
                  _createVNode(_unref(SingleLine), {
                    modelValue: formData.value.username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.username) = $event)),
                    onEnter: submit,
                    icon: "user",
                    errors: firstErrorMessage,
                    id: id
                  }, null, 8, ["modelValue", "errors", "id"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(Label, { label: "Password:" }, {
            default: _withCtx(({id}) => [
              _createVNode(ValidationKeyObserver, { keys: "password" }, {
                default: _withCtx(({firstErrorMessage}) => [
                  _createVNode(_unref(SingleLine), {
                    modelValue: formData.value.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.password) = $event)),
                    onEnter: submit,
                    type: "password",
                    icon: "lock",
                    errors: firstErrorMessage,
                    id: id
                  }, null, 8, ["modelValue", "errors", "id"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (authError.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Incorrect username or password"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(Button, {
              class: "login-button",
              onClick: submit,
              loading: formLoading.value,
              label: "Login"
            }, null, 8, ["loading"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})